export default __webpack_public_path__ + "model-customization9f2e70.png";